import { find } from "lodash";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import MultiSelectList from "../../../components/multi-select-list/multi-select-list";
import { IListItem } from "../../../interface/list-item";
import { IRootState } from "../../../redux/root.reducer";
import { useAppDispatch } from "../../../redux/store";
import { columnsList } from "../../../service/list-columns";
import { ListColumns } from "../enum/list-columns";
import { dataBrowserListSetColumnsAction } from "../redux/lists.actions";

const selector = createSelector(
    [({ dataBrowserList }: IRootState) => dataBrowserList.columns],
    (columns) =>
        columns.map(
            (column) =>
                find(columnsList, ({ id }) => id === column) ?? {
                    id: "",
                    name: "",
                },
        ),
);

const Columns = () => {
    const dispatch = useAppDispatch();

    const selectedColumnsObjects = useSelector(selector);

    const idIndexMap: Record<ListColumns | string, number> = {};

    columnsList.forEach((column, index) => {
        idIndexMap[column.id] = index;
    });

    const onChange = (value: Array<IListItem>) => {
        dispatch(
            dataBrowserListSetColumnsAction(
                value
                    .map(({ id }) => id as ListColumns)
                    .sort((id1, id2) => idIndexMap[id1] - idIndexMap[id2]),
            ),
        );
    };

    return (
        <MultiSelectList
            options={columnsList}
            selectedItems={selectedColumnsObjects}
            onChange={onChange}
            multiline={true}
            menuWidth={300}
        />
    );
};

export default Columns;
